import AiSearchPanel from './AiSearchPanel';

/** Mount once in the authenticated layout: renders the panel. */
const AiSearchHost = () => <AiSearchPanel />;

export default AiSearchHost;
